export default __webpack_public_path__ + "static/char-v-32-jam-bc04cbf6f41261ae5518f194a306fbbd.mp4";